module.exports = __webpack_public_path__ + "static/media/total_pending.8c98f0b3.svg";